import { render, staticRenderFns } from "./NegativeOptionCheckbox.vue?vue&type=template&id=06ee4740&scoped=true&"
import script from "./NegativeOptionCheckbox.vue?vue&type=script&lang=js&"
export * from "./NegativeOptionCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./NegativeOptionCheckbox.vue?vue&type=style&index=0&id=06ee4740&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ee4740",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
